import { render, staticRenderFns } from "./PushReg.vue?vue&type=template&id=4b1dc96e&scoped=true"
import script from "./PushReg.vue?vue&type=script&lang=js"
export * from "./PushReg.vue?vue&type=script&lang=js"
import style0 from "./PushReg.vue?vue&type=style&index=0&id=4b1dc96e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1dc96e",
  null
  
)

export default component.exports